import { startOfDay } from "date-fns";
import { parseInputDate } from "./constants";

export type DateRangeValidationErrorKey =
  | "invalidDate"
  | "fromAfterTo"
  | "futureDate";

export interface DateRangeValidation {
  isValid: boolean;
  errorKey?: DateRangeValidationErrorKey;
}

interface DateRangeValidationOptions {
  maxDate?: Date;
}

export const validateCompleteDateRange = (
  range: {
    from: string;
    to: string;
  },
  options: DateRangeValidationOptions = {},
): DateRangeValidation => {
  if (!range.from || !range.to) {
    return { isValid: true };
  }

  const from = parseInputDate(range.from);
  const to = parseInputDate(range.to);
  if (!from || !to) {
    return { isValid: false, errorKey: "invalidDate" };
  }

  const normalizedFrom = startOfDay(from);
  const normalizedTo = startOfDay(to);

  if (normalizedFrom > normalizedTo) {
    return { isValid: false, errorKey: "fromAfterTo" };
  }

  const maxDate = options.maxDate ? startOfDay(options.maxDate) : undefined;
  if (maxDate && (normalizedFrom > maxDate || normalizedTo > maxDate)) {
    return { isValid: false, errorKey: "futureDate" };
  }

  return { isValid: true };
};
